import type { OfferVM } from "./types";

export function derivePlatforms(offers: OfferVM[]): string[] {
  const set = new Set<string>();
  for (const o of offers) for (const p of o.platforms) set.add(p);
  return [...set].sort();
}
